import React from 'react';
import moment from 'moment';

import Formatter from '../../psuite-js/helpers/formatter';
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import Typography from "material-ui/Typography";
import Invoice from "../Invoice";
import Dialog, { DialogContent } from 'material-ui/Dialog';
import VisitHelper from './../../helpers/Visit';

class CustomerListItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show_subrow: false,
            open_invoices_dialog: false
        };
    }

    toggleSubrow() {
        this.setState({ show_subrow: !this.state.show_subrow });
    }

    getInvoiceValueByLabel(data, label) {
        const item = data.find(item => item.label === label) || {};
        return item.value || null;
    }

    getStatusIcon(status) {
        let className;
        let icon;
        let title;

        switch(status) {
            case 'canceled':
                className = 'c-red';
                icon = 'close';
                title = 'Cancelada / Devolvida';
                break;

            case 'delivered':
            case 'out_of_plan':
                className = 'c-green';
                icon = 'done';
                title = 'Entregue';
                break;

            case 'arrived':
                className = 'c-orange';
                icon = 'beenhere';
                title = 'Chegou no cliente';
                break;

            case 'pending':
            default:
                className = 'c-gray';
                icon = 'access_time';
                title = 'Pendente';
                break;

        }

        return (
            <i className={`material-icons ${className}`} title={title}>
                {icon}
            </i>
        );
    }

    handleDialogRequestClose() {
        this.setState({open_invoices_dialog: false});
    }

    openInvoicesDialog = (invoice) => {
        this.setState({
            open_invoices_dialog: true,
            info_invoce: Object.assign([], invoice)
        });
    }

    getSubrow() {
        if (!this.state.show_subrow) {
            return null;
        }

        const data = this.props.data;
        const customers = Object.assign([], data.customers);

        const invoices = customers.map(customer => {
            const payload = Object.assign({}, customer.payload);
            const dataInvoices = Object.assign([], payload.invoices);
            const canceled_reason = payload.canceled_reason || null;

            dataInvoices.push({label: 'STATUS', value: this.getStatusIcon(customer.status)});
            dataInvoices.push({label: 'ID', value: customer.id});

            if (customer.status === 'canceled') {
                dataInvoices.push({label: 'canceled_reason', value: canceled_reason});
            }

            return dataInvoices;
        });

        const items = invoices.map((invoice, index) => {
            const value = Formatter.formatMoney(this.getInvoiceValueByLabel(invoice, 'VALOR'));
            const info = ((customers[index] && customers[index].payload && customers[index].payload.invoices) || []).sort((a, b) => {
                if(a.label < b.label) return -1;
                if(a.label > b.label) return 1;

                return 0;
            });

            return (
                <tr key={index}>
                    <td>{this.getInvoiceValueByLabel(invoice, 'NFE') || '--'}</td>
                    <td>{value || '--'}</td>
                    <td>{this.getInvoiceValueByLabel(invoice, 'F. PGTO') || '--'}</td>
                    <td>{this.getInvoiceValueByLabel(invoice, 'VENDEDOR') || '--'}</td>
                    <td>{this.getInvoiceValueByLabel(invoice, 'STATUS') || '--'}</td>
                    <td style={{width: '200px'}}>{this.getInvoiceValueByLabel(invoice, 'canceled_reason') || ''}</td>

                    {
                        info.length > 4 && (
                            <td>
                                <IconButton title={'Clique para exibir informações extras da nota fiscal'}
                                            style={{float: 'right'}}
                                            onClick={() => ( this.openInvoicesDialog(info) )}>
                                    <i className="material-icons">info</i>
                                </IconButton>
                            </td>
                        )
                    }
                </tr>
            );
        });

        return (
            <tr className="subrow">
                <td colSpan={8}>
                    <table className="subtable">
                        <thead>
                            <tr>
                                <th>NFE</th>
                                <th>VALOR</th>
                                <th>F. PGTO</th>
                                <th>VENDEDOR</th>
                                <th>STATUS</th>
                                <th>OBSERVAÇÕES</th>
                            </tr>
                        </thead>

                        <tbody>
                            {items}
                        </tbody>
                    </table>
                </td>
            </tr>
        );
    }

    getPartial(data) {
        const partial = { arrived: 0, pending: 0, delivered: 0, out_of_plan: 0, canceled: 0 };

        data.forEach(delivery => {
            const key = delivery.status;
            partial[key] = partial[key] + 1;
        });

        return partial;
    }

    getMainStatusIcon(customers) {
        const partial = this.getPartial(customers);

        let status = 'delivered';

        if (partial.canceled > 0) {
            status = 'canceled';
        } else if (partial.arrived > 0) {
            status = 'arrived';
        } else if (partial.pending > 0 && partial.arrived === 0) {
            status = 'pending';
        }

        return this.getStatusIcon(status);
    }

    getMainRow() {
        const data = this.props.data;
        const customer = data.customer || {};
        const customers = data.customers || [];
        const partial = this.getPartial(customers);
        const countDelivered = partial.delivered + partial.out_of_plan;
        const didVisit = VisitHelper.didVisit(customers);

        return (
            <tr onClick={this.toggleSubrow.bind(this)}>
                <td>{Formatter.formatCNPJorCPF(customer.nin)}</td>
                <td>{customer.name}</td>
                <td>{Formatter.formatAddressJson(customer.address)}</td>
                <td>{moment(data.delivery_eta_at).format('DD/MM/YYYY')}</td>
                <td>{`${countDelivered} / ${customers.length}`}</td>
                <td>
                    { didVisit ? <i className="material-icons c-green" title={'Realizou visita'}>done</i> : <i className="material-icons c-orange">alarm</i> }
                </td>
                <td>
                    <div className="td-item">
                        <i className="material-icons">settings_backup_restore</i> {partial.canceled}
                    </div>
                </td>
                <td>{this.getMainStatusIcon(customers)}</td>
            </tr>
        )
    }

    render() {
        return (
            <tbody>
                <Dialog
                    open={this.state.open_invoices_dialog}
                    onRequestClose={this.handleDialogRequestClose.bind(this)}>

                    <Toolbar className="toolbar">
                        <IconButton onClick={this.handleDialogRequestClose.bind(this)}>
                            <i className="material-icons">close</i>
                        </IconButton>

                        <Typography type="title" color="inherit">
                            <div className="title">Informações</div>
                        </Typography>
                    </Toolbar>

                    <DialogContent>
                        <Invoice info_invoce={this.state.info_invoce} />
                    </DialogContent>
                </Dialog>

                {this.getMainRow()}
                {this.getSubrow()}
            </tbody>
        );
    }

}

CustomerListItem.defaultProps = {
    data: {}
}

export default CustomerListItem;



// WEBPACK FOOTER //
// ./src/components/Delivery/CustomerListItem.js